module.exports = __webpack_public_path__ + "static/media/banner_glipbox_mobile.4a4a5c30.png";